import { API_V2_ROOT } from "@/config";
import type { Wtm2RiskLevel } from "@/trackers/types";

export type TrackerAlternative = {
  kind: "destination" | "video" | "maps";
  name: string;
  slug: string;
};

export type PublicTrackerDetails = {
  trackerKey: string;
  trackerName: string;
  domains: string[];
  category: string;
  description: string;
  riskLevel: Wtm2RiskLevel;
  collectsPHI: boolean;
  supportsBAA: "yes" | "no" | "maybe";
  guidance: {
    whyFlagged: string;
    whatToDo: string;
    whoCanFixIt: string;
    alternative: TrackerAlternative | null;
  };
  sharedBy?: string;
  note?: string;
};

export async function fetchPublicTrackerDetails(
  trackerKey: string,
  shareId?: string,
): Promise<PublicTrackerDetails> {
  const path = `${API_V2_ROOT}/v2/public/wtm/trackers/${encodeURIComponent(trackerKey)}`;
  const url = shareId ? `${path}?share=${encodeURIComponent(shareId)}` : path;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Unable to load tracker details");
  }
  return response.json();
}
